import Button from './LearningPostButton.jsx';
import Question from './Question.jsx';
import './LearningPost.css'
import PropTypes from 'prop-types';

LearningPost.propTypes = {
  post: PropTypes.object.isRequired
};

import users from '../assets/learning-feed/users.json';

function getPostAge( postDate ) {
  const currentDate = new Date();
  const postDateObject = new Date(postDate);
  const diff = currentDate - postDateObject;
  const minutes = Math.floor(diff / 60000);
  if (minutes < 60) {
    return minutes + 'min';
  } else {
    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return hours + 'h';
    } else {
      const days = Math.floor(hours / 24);
      return days + 'd';
    }
  }
}

export default function LearningPost( {post} ) {

  const author = users.users.find( user => user.username === post.author );
  const age = getPostAge(post.date);

  return (
    <div className="learning-post-container">
      <img src={"/learning-feed/avatars/" + author.avatar} alt={post.author} className="learning-post-avatar"/>
      <div className="learning-post-main">
        <div className="learning-post-header">
          <div className="learning-post-details">
            <div className="learning-post-name">{author.name}</div>
            <div className="learning-post-account">{author.username}</div>
            <div className="learning-post-age">{age}</div>
          </div>
          <div className="learning-post-menu">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                 stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round"
                    d="M6.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM12.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM18.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"/>
            </svg>
          </div>
        </div>
        <div className="learning-post-content">
          <h3 className="learning-post-title">{post.title}</h3>
          {
            post.contents.map( (content, index) => {
              if (content.type === 'text') {
                return <p key={index} className="learning-post-text">{content.text}</p>
              } else if (content.type === 'image') {
                return <img key={index} src={"/learning-feed/" + content.source} alt={content.alt} className="learning-post-image"/>
              } else if (content.type === 'question') {
                return <Question question={content} key={index} />
              }
            })
          }
        </div>
        <div className="learning-post-footer">
          <Button icon="like" caption={post.likes.toString()} active={post.liked} />
          <Button icon="comment" caption={post.comments.length.toString()} active={post.commented}/>
          <Button icon="bookmark" active={post.bookmarked} />
          <Button icon="explore" />
          <Button icon="share" />
        </div>
      </div>
    </div>
  )
}